(ns app.front.ui.table
  "This is all mostly deprecated, head on to app.front.ui.sortable-table"
  (:require [app.front.ui.contextual-menu :as ctx-menu]
            [app.front.ui.dnd :as dnd]
            [app.front.ui.sortable-table :as sortable-table]
            [app.front.ui.status :as ui-status]
            [app.front.ui.util :as uiu]
            [app.front.util :as futil :refer [for-frag]]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.front.media-query :as media-query]
            [core.util.util :as util]
            [potpuri.core :as p]
            [reagent.core :as r]
            [schema-tools.core :as st]))

(defn table-header-sortable
  "Produces a `th` element supporting sorting like Carbon data table.
   The arguments are:
   `tr`        i18n translation function
   `sorting`   an atom containing a single two-elem vector, with attribute and bool descending?: `[:attribute-in-use true]`
   `attribute` the keyword key for this header, used as sorting key and dictionary key for the i18n header text"
  [tr sorting attribute opts]
  [:th.sortable (or opts {})
   (let [active?     (= attribute (first @sorting))
         descending? (and active? (second @sorting))]
     [:button.bx--table-sort
      {:class    (when active?
                   "bx--table-sort--active")
       :on-click (fn [_]
                   (reset! sorting [attribute (if active?
                                                (not (second @sorting))
                                                false)]))}
      [:span.bx--table-header-label
       (tr [attribute])]
      (cc/icon {:icon        (cond
                               descending? i/chevron-down
                               active? i/chevron-up
                               :else i/chevron-small-up-down)
                :class-name  (if active?
                               "bx--table-sort__icon"
                               "bx--table-sort__icon-unsorted")
                :fill        "black"
                :description (if descending?
                               (tr [:search/sort-descending])
                               (tr [:search/sort-ascending]))})])])

(defn table-header-checkbox
  "Produces a `th` element for a select-all checkbox like Carbon data table.
   The arguments are:
   `id`        unique id for the input
   `label`     the text used as ARIA label for the input, not displayed visually
   `on-change` the function fired by clicking on the textbox
   `disabled?` if true, checkbox is disabled (default false)
   `checked?`  the checkbox state. If nil (default), no explicit state."
  ([id label on-change]
   (table-header-checkbox id label on-change false))
  ([id label on-change disabled?]
   (table-header-checkbox id label on-change disabled? nil))
  ([id label on-change disabled? checked?]
   [:th.bx--table-column-checkbox
    [:input.bx--checkbox (p/assoc-if {:id        id
                                      :name      "select-all"
                                      :type      "checkbox"
                                      :disabled  disabled?
                                      :on-change #(on-change (-> % .-target .-checked))}
                                     :checked checked?)]
    [:label.bx--checkbox-label {:for        id
                                :aria-label label}]]))

(defn- expand-button [{:keys [on-expand key expanded? tr]}]
  [:td.bx--table-expand
   [:button.bx--table-expand__button
    {:on-click (partial on-expand key)}
    (cc/icon {:icon        (if expanded?
                             i/chevron-up
                             i/chevron-down)
              :description (if expanded?
                             (tr [:carbon.table.row.collapse])
                             (tr [:carbon.table.row.expand]))})]])

(defn get-parent-row
  "Given a DOM element, return the table row that the element belongs to, or nil if not in a table"
  [el]
  (when el
    (if (-> ^DOMStringMap (.-dataset el) .-parentRow (= "true"))
      el
      (recur (.-parentElement el)))))

(defn- table-external-expand-state [{:keys [expandable? tr expanded? on-expand on-select selected] :as opts} headers rows]
  (r/with-let [*hovering-row (r/atom nil)]
    (let [selectable? (and on-select selected)]
      [:table.bx--data-table
       (select-keys opts [:class])
       (when headers
         [:thead
          (into
            [:tr
             (when selectable? [:th.bx--table-column-checkbox
                                (cc/checkbox {:id         "select-all"
                                              :label-text (tr [:select/all])
                                              :hide-label true
                                              :checked    (-> selected seq boolean)
                                              :on-change  (fn [_]
                                                            (if (seq selected)
                                                              (on-select selected)
                                                              (on-select (map :key rows))))})])
             (when expandable? [:td.expansion-column])]
            (filter some? headers))])
       (into
         [:tbody]
         (->> rows
              (mapcat
                (fn [{:keys [expanded-content key cols opts]}]
                  (let [expanded? (expanded? key)]
                    (cond-> [(into
                               (into
                                 [:tr (r/merge-props {:class           (futil/cs (when expandable?
                                                                                   "bx--parent-row")
                                                                                 (when expanded?
                                                                                   "bx--expandable-row cloudpermit--expandable-parent-row")
                                                                                 (when (= @*hovering-row key)
                                                                                   "bx--expandable-row--hover"))
                                                      :key             key
                                                      ;; data-parent-row is needed for expandable rows
                                                      :data-parent-row true}
                                                     opts)]
                                 [(when selectable?
                                    [:td.bx--table-column-checkbox
                                     (cc/checkbox {:id         (str "select_" key)
                                                   :label-text (tr [:select/select])
                                                   :hide-label true
                                                   :checked    (contains? selected key)
                                                   :on-change  (fn [_] (on-select [key]))})])
                                  (when expandable?
                                    [expand-button (util/mmap on-expand key expanded? tr)])])
                               (->> (filter some? cols)
                                    (map-indexed (fn [i {:keys [opts content]}]
                                                   [:td (merge {:key (str key "-col-" i)} opts) content]))))]
                      expanded? (concat [(into
                                           [:tr.bx--expandable-row.cloudpermit--expandable-row
                                            {:data-child-row true
                                             :on-mouse-over  #(reset! *hovering-row key)
                                             :on-mouse-out   #(reset! *hovering-row nil)}]
                                           [(when selectable?
                                              [:td.bx--table-column-checkbox])
                                            [:td {:col-span (->> cols (filter some?) count inc)
                                                  :key      (str key "-expansion")}
                                             [:div.bx--child-row-inner-container expanded-content]]])])))))))])))


(defn- create-styles [{:keys [flex min-width max-width width word-break]
                       :or   {flex 1 min-width "0px"}}]
  (p/assoc-if
    {:flex      flex
     :min-width (if width width min-width)
     :max-width (if width width (if (some? max-width) max-width "none"))
     :width     (if width width "auto")}
    :word-break word-break))

(defn- responsive-col [{:keys [headers sub-header? headerless? lg-screen? breakpoint]} i {:keys [opts content]}]
  (let [{col-title :title} (get headers i)
        header-col?        (and headers (not headerless?))]
    ^{:key (str key "-col-" i)}
    [:<>
     ;; Small view cell
     (when (and content (not lg-screen?))
       [:div.md:flex.md:items-center
        {:class (futil/cs (str breakpoint ":hidden")
                          (or (:col-class opts) "block md:flex md:flex-1")
                          (when (or sub-header?
                                    (> i 0))
                            (if headerless? "mt-2" "mt-4")))}
        (when header-col?
          [:div.mb-2.md:mb-0.font-bold.leading-tight.w-full.md:w-1-4.md:min-w-1-4.md:mr-2.text-ui-night-sky.uppercase.tracking-wide.text-xs
           {:class (futil/cs (when sub-header? "hidden")
                             (str breakpoint ":hidden "
                                  breakpoint ":w-full"))}
           col-title])
        [:div
         (merge (dissoc opts :col-class)
                {:class [(if header-col?
                           "w-3-4"
                           "w-full")]})
         content]])
     ;; Large view cell
     (when lg-screen?
       [:div.hidden.print:block.mb-4.pr-2
        (-> (assoc opts :style (create-styles (get headers i)))
            (dissoc :col-class)
            (update :class str " " breakpoint ":block " breakpoint ":mb-0"))
        content])]))

(defn- responsive-table-row [{:keys [expanded?
                                     main-row-class-override
                                     expandable?
                                     hovering-key
                                     on-hover-fn
                                     on-end-hover
                                     row-class-override
                                     breakpoint-str
                                     on-expand
                                     tr
                                     lg-screen?
                                     headers
                                     headerless?
                                     has-link?
                                     expanded-row-class
                                     main-row-expanded-class-override]}
                             {:keys [expanded-content key cols opts sub-header? link
                                     actions row-class focus? status-border expanded-class row-expanded-class-override
                                     target-props
                                     draggable-props]}]
  (let [expanded?           (expanded? key)
        {:keys [description
                href]}      link]
    (when-not key
      (js/console.warn
        "Missing React key (check your idfunc returns a value or a key is provided manually) for a table row with cols:"
        (pr-str cols)))
    ^{:key key}
    [:<>
     [:div.flex.w-full.items-center
      (r/merge-props {:class           [main-row-class-override
                                        (when expandable?
                                          "bx--parent-row")
                                        (when expanded?
                                          "bx--expandable-row")
                                        (when (and expanded? main-row-expanded-class-override)
                                          main-row-expanded-class-override)
                                        (when (= hovering-key key)
                                          "bx--expandable-row--hover")]
                      :data-parent-row true}
                     target-props
                     opts)
      (when expandable?
        [:div {:class ["self-stretch rounded-md rounded-r-none"
                       (when (and expanded? row-expanded-class-override)
                         row-expanded-class-override)
                       row-class]}
         (when expanded-content
           [:button.bx--table-expand__button
            {:on-click (partial on-expand key)}
            (cc/icon {:icon        (if expanded?
                                     i/chevron-up
                                     i/chevron-down)
                      :description (if expanded?
                                     (tr [:carbon.table.row.collapse])
                                     (tr [:carbon.table.row.expand]))})])])
      [:div.flex.flex-1.flex-col
       {:class [(or row-class-override
                    (str "p-4 " breakpoint-str ":items-center"))
                (str breakpoint-str ":mb-0 " breakpoint-str ":flex-row")
                row-class
                (when has-link?
                  "rounded-r-none")]}
       (->> cols
            (filter some?)
            (map-indexed (partial responsive-col (util/mmap {:lg-screen? lg-screen?
                                                             :breakpoint breakpoint-str}
                                                            headers sub-header? headerless?)))
            doall)]
      (when draggable-props
        [:div {:class "cursor-move"
               :style {:width "30px"}}
         [:div.inline-block draggable-props
          (cc/icon {:icon        i/draggable
                    :description (tr [:reorder])})]])
      (when actions ;; don't reserve space if no actions provided for any row
        (let [content [(util/mmap actions)]]
          (if (ctx-menu/to-sections {} content)
            [ctx-menu/menu
             content
             (util/mmap {:toggle-props (merge {:class   "h-full bg-white z-0"
                                               :button? true}
                                              (when (some? tr)
                                                {:aria-label (tr [:actions])}))}
                        tr)]
            ;; spacer to match with missing menu when no items
            [:div.lg:w-9])))
      (when has-link?
        [:div.self-stretch.flex
         (if href
           (cc/button {:href             href
                       :class-name       (futil/cs "self-stretch only-icon-button w-8 min-h-4"
                                                   (when focus? "rounded-l-none bg-ui-blue"))
                       :icon             i/chevron-right
                       :icon-description description}
                      "")
           [:div.lg:w-8 (when focus? {:class "bg-ui-blue-20 border-ui-blue border-2 border-solid border-l-0"})])])]
     (when expanded?
       [:div.bx--expandable-row.cloudpermit--expandable-row
        (p/assoc-if
          {:data-child-row true
           :on-mouse-over  (on-hover-fn key)
           :on-mouse-out   on-end-hover}
          :class expanded-row-class)
        [:div]
        [:div {:col-span (->> cols (filter some?) count)
               :key      (str key "-expansion")}
         [:div.mt-5.pb-4
          {:class [(when (and status-border (not focus?))
                     (str "first:border-l-4 -ml-1 border-solid rounded-b-md " status-border))
                   (when expanded-class
                     expanded-class)]}
          [:div.border-t.border-ui-gray.border-solid.mt-2.px-3.pt-2
           expanded-content]]]])]))

(defn- responsive-table-external-expand-state [{:keys [expandable?
                                                       headerless?
                                                       tr
                                                       expanded?
                                                       on-expand
                                                       header-class-override
                                                       main-row-class-override
                                                       row-class-override
                                                       table-mode-breakpoint
                                                       expanded-row-class
                                                       main-row-expanded-class-override
                                                       can-reorder?
                                                       has-actions?]
                                                :as   opts}
                                               headers
                                               rows]
  (r/with-let [*hovering-row (r/atom nil)
               on-hover-fn   (memoize
                               ;; optimize for less changes to DOM event handlers
                               (fn [key]
                                 #(reset! *hovering-row key)))
               on-end-hover  #(reset! *hovering-row nil)]
    (let [headers                    (->> headers
                                          (filter some?)
                                          vec)
          headers-with-expandability (cond->> headers
                                       expandable?  (into [{:title "" :width "30px"}])
                                       can-reorder? (#(conj % {:title "" :width "30px"}))
                                       has-actions? (#(conj % {:title "" :width "36px"})))
          has-link?                  (some :link rows)
          breakpoint-str             (name (or table-mode-breakpoint :lg))
          lg-screen?                 (<sub [::media-query/breakpoint-matches? (or table-mode-breakpoint :lg)])]
      [:div
       (select-keys opts [:class])
       (when (and headers (not headerless?))
         [:div.hidden.w-full {:class (case table-mode-breakpoint
                                       ;; Need to spell these out to avoid being purged
                                       :xl  "xl:flex"
                                       :xxl "xxl:flex"
                                       :md  "md:flex"
                                       "lg:flex")}
          [:div.flex.flex-1 {:class (or header-class-override "p-4 bg-ui-gray font-bold")}
           (for-frag [{:keys [title class] :as header} headers-with-expandability]
             [:div {:class (str class " pr-2")
                    :style (create-styles header)}
              title])]
          (when has-link?
            [:div.w-8])])
       [:div
        (->> rows
             (map
               (fn [row]
                 ^{:key (:key row)}
                 [responsive-table-row
                  (util/mmap {:hovering-key @*hovering-row}
                             expanded?
                             main-row-class-override
                             expandable?
                             on-hover-fn
                             on-end-hover
                             row-class-override
                             breakpoint-str
                             on-expand
                             tr
                             lg-screen?
                             headers
                             headerless?
                             has-link?
                             expanded-row-class
                             main-row-expanded-class-override)
                  row]))
             doall
             (cons :<>)
             vec)]])))


(defn ^:deprecated table
  "DEPRECATED use sortable-table/table for all new code

   Produces a `table` element with styling taken from Carbon data table.

   You can expand a single row by default by providing :default-expanded-key in opts. The value must correspond to a key
   provided for a table row.

   The arguments are:
   `opts`     a map optionally containing {:expandable? bool, :tr translation-fn, :class \"class-name\" :default-expanded-key str}
   `headers`  a list of `th` elements
   `rows`     a list of maps that represent the table rows. The maps look like this:
              {:expanded-content  anything
               :key               string or keyword React key for the row
               :cols              a list of maps representing the row columns: [{:opts {...td attrs...}, :content anything},...]
               :opts              options for the row element}

  `expandable?` whether it's possible to expand a row
  `tr`          translation function"
  [{:keys [default-expanded-key] :as opts} headers rows]
  (r/with-let [*expanded-rows (r/atom (if (some? default-expanded-key)
                                        #{default-expanded-key}
                                        #{}))
               expanded?      (fn [key] (contains? @*expanded-rows key))
               on-expand      (fn [key] (swap! *expanded-rows
                                               (if (expanded? key) disj conj) key))
               expand-opts    (util/mmap expanded? on-expand)]
    [table-external-expand-state (merge opts expand-opts) headers rows]))

(defn ^:deprecated responsive-table
  "DEPRECATED use sortable-table/table for all new code

   Produces a responsive table.

   You can expand a single row by default by providing :default-expanded-key in opts. The value must correspond to a key
   provided for a table row.

   The arguments are:
   `opts`     a map optionally containing {:expandable?          bool
                                           :tr                   translation-fn
                                           :class                \"class-name\"
                                           :default-expanded-key str
                                           :row-class-override   str
                                           :header-class-override str
                                           :table-mode-breakpoint :lg  ; What breakpoint is the minimum for table mode, default :lg
                                           :headerless?          bool} ; Does not render the title bar, but column widths
                                                                         defined in header still take effect
   `headers`  a list of table headers. Header width values are inherited by the whole column:
              {:title     string
               :opts      options for the header element
               :flex      optional flex value (default 1, every column is equally wide)
               :max-width optional max-width, any CSS width value, default none
               :min-width optional min-width, any CSS width value, default 0
               :width     optional fixed width, any CSS width value, default auto}
   `rows`     a list of maps that represent the table rows. The maps look like this:
              {:expanded-content  anything
               :key               string or keyword React key for the row
               :sub-header?       boolean, whether this row is a subheader for grouping rows
               :cols              a list of maps representing the row columns: [{:opts {...td attrs...}, :content anything},...]
               :opts              options for the row element}

  `expandable?` whether it's possible to expand a row
  `tr`          translation function"
  [{:keys [default-expanded-key on-expand] :as opts} headers rows]
  (r/with-let [*expanded-rows (r/atom (if (some? default-expanded-key)
                                        #{default-expanded-key}
                                        #{}))
               expanded?      (fn [key] (contains? @*expanded-rows key))
               on-expand-int  (fn [key] (swap! *expanded-rows (if (expanded? key) disj conj) key))]
    [responsive-table-external-expand-state
     (assoc opts
            :expanded? expanded?
            :on-expand (if on-expand
                         (fn [key]
                           (let [expanded? (contains? (on-expand-int key) key)]
                             ;; only trigger on-expand if expanded, not on collapse
                             (on-expand key expanded?)))
                         ;; if only internal expand state, do not change function ref on render
                         on-expand-int))
     headers
     rows]))


(def common-col-opts
  [:flex :max-width :min-width :width :word-break])

(defn do-tr [tr content]
  (if (and (keyword? content) tr)
    (tr [content])
    content))

(def modern-header-class
  "font-light font-bold pl-2")

(def modern-row-class
  "pl-2 lg:py-0 py-3 lg:items-center rounded-md")

(def modern-main-class
  "bg-ui-white my-2 border-solid border-gray-300 modern-responsive-table-row rounded-md border")

(def modern-main-row-expanded-class
  "rounded-b-none border-b-0 border-l border-r border-t")

(def modern-row-expanded-class
  "border-solid border-b border-l border-r border-gray-300 -mt-5 rounded-b-md bg-ui-white")

(defn modern-row-class-for-item [focus? link status-border cols]
  (futil/cs (if focus?
              (futil/cs "border-solid border-2 border-ui-blue pl-3 bg-ui-blue-20"
                        (when link
                          ;; even if no link here (i.e. nil href), we still draw the spacer.
                          "border-r-0"))
              (when status-border
                (str "first:border-l-4 border-solid -ml-1 " status-border)))
            (when (->> cols
                       (map last)
                       (some :truncate?))
              "lg:truncate")))

(defn- item->cols [item cols]
  (->> cols
       (filter some?)
       (mapv (fn [[_ extractor {:keys [truncate?] :as opts}]]
               (merge {:content (if (fn? (extractor item))
                                  ((extractor item) item)
                                  (extractor item))
                       :opts    {:class (futil/cs (:class opts)
                                                  "lg:py-3"
                                                  (when truncate?
                                                    "lg:truncate"))}}
                      (select-keys opts common-col-opts))))))

(defn- item->modern-row [get-focus?
                         link
                         get-status
                         cols
                         id-func
                         expanded-func
                         make-actions
                         tr
                         augment-target-props
                         augment-draggable-props
                         item]
  (let [focus?        (and get-focus? (get-focus? item))
        href          (when link ((:make-href link) item))
        status-border (and get-status
                           (-> item
                               get-status
                               ui-status/status->border-color-class))]
    (merge {:cols                        (item->cols item cols)
            :key                         ((or id-func :db/id) item)
            :focus?                      focus?
            :status-border               status-border
            :row-class                   (modern-row-class-for-item focus? link status-border cols)
            :row-expanded-class-override (str "rounded-t-md rounded-b-none " (when focus? "border-b-0"))}
           (when (and augment-target-props augment-draggable-props)
             {:target-props    (augment-target-props {} item)
              :draggable-props (augment-draggable-props {} item)})
           (when focus?
             {:expanded-class "border-solid border-t-0 border-2 border-ui-blue pl-3 bg-ui-blue-20 rounded-b-md"})
           (when expanded-func
             {:expanded-content (expanded-func item)})
           (when make-actions
             {:actions (make-actions item)})
           (when href
             (let [description (:description link)]
               {:link {:href        href
                       :description (do-tr
                                      tr
                                      (if (fn? description)
                                        (description item)
                                        description))}})))))

(defn modern-responsive-table-content [{:keys [row-class-override
                                               expanded-func
                                               headerless?
                                               tr
                                               class
                                               on-expand
                                               cols
                                               get-focus?
                                               link
                                               get-status
                                               id-func
                                               make-actions
                                               items
                                               augment-target-props
                                               augment-draggable-props
                                               expanded-row-keys]}]
  [(if expanded-row-keys
     responsive-table-external-expand-state
     #_{:clj-kondo/ignore [:deprecated-var]} responsive-table)
   (util/mmap {:header-class-override            modern-header-class
               :row-class-override               (futil/cs modern-row-class
                                                           (when row-class-override row-class-override))
               :main-row-class-override          modern-main-class
               :main-row-expanded-class-override modern-main-row-expanded-class
               :expanded-row-class               modern-row-expanded-class
               :expandable?                      (some? expanded-func)
               :can-reorder?                     (some? augment-draggable-props)
               :has-actions?                     (some? make-actions)
               :expanded?                        (when expanded-row-keys
                                                   #(contains? expanded-row-keys %))}
              headerless?
              tr
              class
              on-expand)
   (->> cols
        (filter some?)
        (mapv (fn [[title _ opts]]
                (merge {:title (do-tr tr title)}
                       (select-keys opts common-col-opts)))))
   (->> items
        (mapv (partial item->modern-row
                       get-focus?
                       link
                       get-status
                       cols
                       id-func
                       expanded-func
                       make-actions
                       tr
                       augment-target-props
                       augment-draggable-props)))])

(defn modern-responsive-table
  "SEMI-DEPRECATED: use sortable-table/table instead, it has the same API. Except for :empty-placeholder!

   A responsive-table, using the latest Cloudpermit styling.

  `:id` - required if on-reorder or configurable? is given. Without id, overflow behaviour does not work.
  `:cols` - tuples of header (keyword, string or component)
                    + extractor (a fn item -> component)
                    + opts (optional, can have
                               * `:truncate?` boolean that controls wrapping,
                               and the CSS passthrough props `:width`, `:flex`, `:min-width`, `:max-width`)
  `:items` - collection of anything
  `:tr` - translation function
  `:id-func` - item -> row key (defaults to `:db/id`)
  `:link` - map w/ `:make-href` function item -> url and `:description` keyword or string
  `:make-actions` - a function that returns actions for `app.front.ui.contextual-menu`
  `:get-focus?` - function item -> boolean that tells whether the current row should be
                    highlighted
  `:get-status` - function item -> `:critical`, `:warning`, `:attention`, `:notification`, `:task` or `:ok` or `nil`
  `:on-select` - function called when a row selected, params are `checked` boolean, and `key` of the row
                works only when `upgraded-sortable-tables` feature flag enabled
  `:selection` - set of selected row keys
  `:empty-placeholder` - keyword, string or component to show when empty
  `:on-reorder` - function for reordering the items - when applied wraps the component into dnd/wrap-dnd
  `:expanded-func` - function for rendering the expanded content for the row
  `:expanded-row-keys` - set of keys/ids of extended rows, if you want to control all expansion state externally
  `:on-expand` - function [item expanded?] called with the id of row on expand (or on close), mandatory
                 with :expanded-row-keys
  `:configurable?` - should the column configuration modal be available, only for the new sortable-table implementation
                     NOTE: requires unique :id
  `:initial-sorting` - a vector of [attribute :asc/:desc] to set the initial sorting state"
  [{:keys [cols items tr id-func link make-actions get-focus? get-status
           empty-placeholder class headerless? expanded-func on-select selection
           row-class-override on-reorder id on-expand expanded-row-keys
           configurable? initial-sorting]}]
  (if (seq items)
    (let [props (util/mmap row-class-override
                           expanded-func
                           headerless?
                           tr
                           class
                           on-expand
                           on-select
                           selection
                           cols
                           get-focus?
                           link
                           get-status
                           id-func
                           make-actions
                           items
                           expanded-row-keys
                           configurable?
                           initial-sorting
                           id)]
      (if (ff/enabled? :feature-flag.id/upgraded-sortable-tables)
        [sortable-table/table (assoc props :on-reorder on-reorder)]
        (if on-reorder
          [dnd/wrap-dnd (util/mmap id items on-reorder)
           (fn [{:keys [augment-draggable-props augment-target-props sorted]}]
             [modern-responsive-table-content
              (merge props
                     (util/mmap {:items sorted}
                                augment-draggable-props
                                augment-target-props))])]
          [modern-responsive-table-content props])))
    [:div (util/mmap class)
     (do-tr tr empty-placeholder)]))

(defn ^:deprecated table-2
  "DEPRECATED use sortable-table/table for all new code

  Alternative UI API for `table`, allows maintaining expansion state externally

  `:id` is a unique identifier for this table

  `:items` is a sequence of things, e.g. maps

  `:header+extractors` is a sequence of header+extractor tuples.
    header is a translation kw, string or component for the first
           row of the table
    extractor is a function i->string-or-component for showing the
              content of the row

  `:expand-component` is a function (f i ix) that takes an item and index and
                      renders an editor

  `:expanded?` is a predicate that operates on an item.

  `:on-expand` is an event handler that takes the item+expanded status as param

  `:id-func` is a function that produces a unique id for an item,
             default `:db/id`

  `:tr` is the translator function

  `:on-reorder` is a handler for when rows are dragged, params are
                item-to-move item-to-move-to"
  [{:keys [id
           items
           header+extractors
           id-func
           tr
           expand-component
           expanded?
           on-expand
           on-reorder]
    :or   {id-func :db/id}}]
  [dnd/wrap-dnd {:id               (str id "-dnd")
                 :items            items
                 :props-for-source {:class "dnd-hilight"}
                 :on-reorder       on-reorder}
   (fn [{:keys [augment-draggable-props augment-target-props sorted]}]
     (let [items-grouped (->> items
                              (group-by id-func)
                              (p/map-vals first))
           expandable?   (some? expand-component)]
       [(if (and expandable? (nil? on-expand))
          #_{:clj-kondo/ignore [:deprecated-var]} table
          table-external-expand-state)
        {:expandable? expandable?
         :tr          tr
         :expanded?   (if expandable?
                        (fn [key]
                          (expanded? (get items-grouped key)))
                        (constantly false))
         :on-expand   (fn [key]
                        (let [item (get items-grouped key)]
                          (on-expand (when (-> item expanded? not) item))))}
        (into []
              (concat
                (for [h+e header+extractors]
                  (cond
                    (keyword? h+e) [:th (tr [h+e])]
                    (-> h+e first keyword?) [:th (tr [(first h+e)])]
                    :else [:th (first h+e)]))
                (when on-reorder
                  [[:th]])))
        (doall
          (map-indexed
            (fn [ix item]
              {:key              (id-func item)
               :expanded-content [expand-component item ix]
               :opts             (cond-> {}
                                   augment-target-props (augment-target-props item))
               :cols             (concat
                                   (for [h+e header+extractors]
                                     (let [extractor (if (keyword? h+e) h+e (second h+e))]
                                       {:opts    {}
                                        :content (extractor item)}))
                                   (when on-reorder
                                     [{:opts    (augment-draggable-props {} item)
                                       :content [:div
                                                 (cc/icon {:icon        i/draggable
                                                           :description (tr [:reorder])})]}]))})
            sorted))]))])

(defn add-new-button
  "A button that goes along with table and allows adding new rows"
  [{:keys [tr] :as props} & children]
  (cc/button
    (-> (r/merge-props {:icon             i/plus
                        :icon-description (tr [:add])}
                       props)
        (st/select-schema cc/ButtonOptions))
    (cond (empty? children)
          (tr [:add])
          (and (-> children count (= 1)) (keyword? (first children)))
          (tr [:inspection.template/create])
          :else
          children)))

(def add-to-table-row
  "A component that tries to match the table styling, for adding new
  items to a table."
  (uiu/wrap-in :div.flex.content-end.mt-4 {}
               :div.inline-block.ml-4 {}))
